import React from "react";
import styles from "./eight.module.scss";
import FAQ from "../../containers/Home/FAQ";

const Eight = () => {
  return (
    <div className={styles.root}>
      <section className={styles.top}>
        <span className={styles.title}>FAQS</span>
        <span className={styles.description}>
          We've collected the most commonly asked questions to help you find the
          answers you need. If you have any additional questions, don't hesitate
          to reach out via our chat support.
        </span>
      </section>
      <section className={styles.bottom}>
        <FAQ q="What is the Sentinel Network?">
          <p>
            The Sentinel Network is a decentralized, blockchain-based node
            marketplace where anyone can buy and sell bandwidth, enabling
            multiple VPN providers access to its network offering users enhanced
            privacy and security through a more diversified, robust, and
            competitive framework than other VPN applications and bandwidth
            providers.
          </p>
          <p>
            Anyone can build a dVPN application on top of Sentinel that is more
            secure and trustworthy than any centralized VPN application.
          </p>
        </FAQ>
        <FAQ q="What are Sentinel dVPN apps?">
          <p>
            Sentinel dVPN apps are applications that provide access to
            decentralized Virtual Private Network (dVPN) services through a
            peer-to-peer bandwidth marketplace on the Sentinel Network, offering
            enhanced privacy and anonymity, resilience against censorship,
            transparent and trustless operations using blockchain technology,
            and a community-driven economic model, all while being open-source
            for continuous community-led improvement and transparency.
          </p>
          <p>
            Find all our whitelabels here{" "}
            <a
              href="https://docs.sentinel.co/getting-started/apps"
              target="_blank"
              rel="noreferrer"
            >
              https://docs.sentinel.co/getting-started/apps
            </a>
          </p>
        </FAQ>
        <FAQ q="What is the difference between a VPN and a dVPN?">
          <p>
            A traditional VPN is a centralized service operated by a single
            entity, which can create vulnerabilities and require users to trust
            the provider with their data. In contrast, a dVPN (decentralized
            Virtual Private Network) operates on a decentralized, distributed
            network of nodes run by various individuals or entities, enhancing
            privacy and security. dVPNs offer greater resistance to censorship
            and targeted attacks due to their decentralized structure and often
            use blockchain technology for added transparency and trust. Unlike
            the subscription-based model of traditional VPNs, dVPNs can feature
            a peer-to-peer marketplace for buying and selling bandwidth,
            providing a dynamic and potentially more economical approach to
            secure internet access.
          </p>
          <p>
            dVPN applications also maintain a standard of being open-sourced,
            offering clear visibility into the back-end architecture and
            establishing a trustless relationship.
          </p>
          <p>
            Learn more about dVPNs here{" "}
            <a
              href="https://docs.sentinel.co/getting-started/dvpn/vpn-vs-dvpn"
              target="_blank"
              rel="noreferrer"
            >
              https://docs.sentinel.co/getting-started/dvpn/vpn-vs-dvpn
            </a>
          </p>
        </FAQ>
        <FAQ q="What is the $DVPN coin?">
          <p>
            The $DVPN coin is the native cryptocurrency of the Sentinel Network,
            serving primarily as a utility medium within its decentralized VPN
            (dVPN) ecosystem. It functions as the transactional currency for
            accessing and paying for VPN services, incentivizing network
            participants by rewarding those who provide bandwidth. Additionally,
            the $DVPN coin may play a role in the governance of the Sentinel
            Network, allowing coin holders to participate in decision-making
            processes. As with other cryptocurrencies, its value is subject to
            market dynamics and can be traded on various cryptocurrency
            exchanges. $DVPN's integration into the Sentinel blockchain ensures
            secure, transparent, and efficient transactions within the network.
          </p>
          <p>
            $DVPN also acts as a form of revenue share as $DVPN stakers earn 20%
            of all payments made to dVPN nodes for bandwidth services.
          </p>
          <p>
            Find out more here{" "}
            <a
              href="https://docs.sentinel.co/getting-started/dvpn-coin"
              target="_blank"
              rel="noreferrer"
            >
              https://docs.sentinel.co/getting-started/dvpn-coin
            </a>
          </p>
        </FAQ>
        <FAQ q="What is the sentinel growth DAO?">
          <p>
            The Sentinel Growth DAO is a community initiative comprised of
            ardent supporters of Sentinel with the goal of educating newcomers,
            creating an environment that’s more fun than formal, organizing
            group gaming events to help spread awareness of Sentinel on a less
            formal basis. , but ultimately using community pooled funds raised
            from network activity to spend on promoting and supporting the
            continued success and growth of decentralized VPN on the Sentinel
            Network.
          </p>
          <p>
            Find out more at{" "}
            <a
              href="https://docs.sentinel.co/getting-started/dao"
              target="_blank"
              rel="noreferrer"
            >
              https://docs.sentinel.co/getting-started/dao
            </a>
          </p>
        </FAQ>
        <FAQ q="What are sentinel Nodes?">
          <p>
            Sentinel nodes form the backbone of the Sentinel Network by
            providing decentralized bandwidth for its VPN services, enhancing
            privacy and security. Operated by individuals globally and
            incentivized with rewards like $DVPN tokens, these nodes ensure a
            resilient, distributed network that resists censorship and promotes
            secure, community-driven internet access.
          </p>
          <p>
            Currently community members can host dVPN nodes that support either
            the Wireguard or the V2Ray protocol.
          </p>
          <p>
            Checkout{" "}
            <a
              href="https://docs.sentinel.co/node-setup"
              target="_blank"
              rel="noreferrer"
            >
              https://docs.sentinel.co/node-setup
            </a>{" "}
            for more
          </p>
        </FAQ>
        <FAQ q="Where do find more information about sentinel?">
          <p>
            <a
              href="https://docs.sentinel.co/ "
              target="_blank"
              rel="noreferrer"
            >
              https://docs.sentinel.co/
            </a>{" "}
            is the best resource to find everything you need to know about
            sentinel.
          </p>
          <p>
            To find the latest information and updates join our Telegram group
            and follow our Twitter
          </p>
        </FAQ>
      </section>
    </div>
  );
};

export default Eight;
